import React, { useState } from 'react'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask';

import { TextField } from '../../default';

function MaskedPhoneField({ id, text, disabled, mask, onlyNumber, fkProps, ...rest }) {
    const [fieldValue, setFieldValue] = useState('');

    const handleChange = evt => {
        if (onlyNumber)
            evt.target.value = (evt.target.value || '').replace(/[^0-9]/g, '')

        if (!disabled)
            fkProps.handleChange(evt)

        const brazilianPhone = evt.target.value.replace(/[^0-9]+/g, '')
        setFieldValue(brazilianPhone)
    }

    return (
        <InputMask
            mask={fieldValue.length <= 10 ? '(99) 9999-9999?' : '(99) 99999-9999'}
            formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
            value={fkProps.values[id]}
            onChange={handleChange}
            onBlur={fkProps.handleBlur}
            disabled={disabled}
            alwaysShowMask={false}
        >
        {inputProps => (
            <TextField
                id={id}
                label={text}
                disabled={disabled}
                helperText={fkProps.touched[id] ? fkProps.errors[id] : ""}
                error={fkProps.touched[id] && Boolean(fkProps.errors[id])}          
                {...inputProps}
                {...rest}
            />
        )}
        </InputMask>
    )
}

MaskedPhoneField.propTypes = {
  id: PropTypes.string.isRequired,
  mask: PropTypes.string.isRequired,
  fkProps: PropTypes.object.isRequired,

  text: PropTypes.string,
  disabled: PropTypes.bool,
  onlyNumber: PropTypes.bool,
}

MaskedPhoneField.defaultProps = {
  text: '',
  disabled: false,
  onlyNumber: true,
}

export default MaskedPhoneField